// extracted by mini-css-extract-plugin
export var cancelButton = "_mv-5";
export var content = "_mv-3";
export var createButton = "_mv-6";
export var drawerContainer = "_mv-0";
export var footer = "_mv-2";
export var header = "_mv-1";
export var orderFormColumn = "_mv-4";